/**
 * Purview CVC Container
 * Handles data fetching and state management
 */

import React, { useEffect, useState } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { PurviewCVCDetails } from "./PurviewCVCDetails";
import { IPurviewCVCContainerProps } from "./PurviewCVC.interfaces";
import { logEvent, logException } from "../../helper/AppInsightsHelper";

export const PurviewCVCContainer: React.FC<IPurviewCVCContainerProps> = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const initializeData = async () => {
            try {
                setIsLoading(true);
                logEvent(
                    "PurviewCVC container initialized",
                    "PurviewCVC",
                    "PurviewCVCContainer",
                    {}
                );

                // Simulate initial setup - actual data fetching done in tab component
                const mockDelay = new Promise(resolve => setTimeout(resolve, 300));
                await mockDelay;

                setIsLoading(false);
            } catch (err) {
                const errorMessage = err instanceof Error ? err.message : "Unknown error occurred";
                setError(errorMessage);
                logException(
                    "PurviewCVC",
                    "PurviewCVCContainer",
                    "initializeData",
                    err as Error,
                    {}
                );
                setIsLoading(false);
            }
        };

        initializeData();
    }, []);

    if (error) {
        return (
            <div style={{ padding: "24px", textAlign: "center" }}>
                <div style={{ color: "#E81123", fontSize: "16px", fontWeight: "600", marginBottom: "12px" }}>
                    Error Loading Data
                </div>
                <div style={{ color: "#605E5C", fontSize: "14px" }}>
                    {error}
                </div>
            </div>
        );
    }

    return (
        <div>
            {isLoading && (
                <div style={{ display: "flex", justifyContent: "center", padding: "48px" }}>
                    <Spinner size={SpinnerSize.large} label="Loading Purview CVC data..." />
                </div>
            )}
            {!isLoading && (
                <PurviewCVCDetails isLoading={isLoading} />
            )}
        </div>
    );
};
